import radianToDegree from "../math/radianToDegree";

export default function generateAngle({ startRadian, endRadian }, cClockwise: boolean, even = true) {
  let _angle = (startRadian - endRadian);
  if (!cClockwise) {
    _angle = endRadian - startRadian;
  }

  let degree = Math.floor(radianToDegree(_angle));
  degree = degree < 0 ? degree + 360 : degree;
  even ? degree = degree % 2 == 1 ? degree + 1 : degree : "";
  return degree;
}